import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to top on every route change (public site + admin). Uses `instant`
// to avoid a visible jump; browsers will animate other in-page scrolls.
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

export default ScrollToTop;
